<template>
  <b-card>
    <FormBuilder
      label="Administrator"
      create
      :fields="fields"
      :loading-submit="$store.state.administratorV2.loadingSubmit"
      @submit="submitData"
    />
  </b-card>
</template>

<script>
import FormBuilder from '@/layouts/components/v2/FormBuilder.vue'
import { BCard } from 'bootstrap-vue'
import fields from '@/field/form/administrator'

export default {
  components: {
    BCard,
    FormBuilder,
  },
  setup() {
    return { fields }
  },
  methods: {
    submitData(data, callback) {
      this.$store.dispatch('administratorV2/create', data)
        .then(() => {
          if (typeof callback === 'function') callback()
          this.$router.push({ name: 'administrators-v2' })
        })
        .catch(err => callback(err))
    },
  },
}
</script>
